












import Vue from 'vue'
import StartDeletionDialog from '@/components/dialogs/privacy/StartDeletionDialog.vue'
import ActionDialog from '@/components/atoms/ActionDialog.vue'

export default Vue.extend({
  components: {
    StartDeletionDialog,
    ActionDialog
  },
  data: () => ({
    dialogVisible: false as boolean
  }),
  methods: {
    showDialog (): void {
      this.dialogVisible = true
    },
    hideDialog (): void {
      this.dialogVisible = false
    }
  }
})
